import { findPostPurchaseCheckout } from 'lib/checkout/checkoutUtils'
import { createSelector } from 'reselect'

export const getBedbankChangeDatesTravellers = createSelector(
  (state: App.State) => state.checkout.cart.existingOrder,
  (state: App.State) => findPostPurchaseCheckout(state.checkout.cart.mode),
  (state: App.State) => state.auth.account,
  (existingOrder, postPurchase, account) => {
    const { email, phone, phonePrefix } = account
    const bedbankItem = existingOrder?.bedbankItems[0]

    // TODO: Extract this into a seperate tours post purchase selector
    const tourItem = existingOrder?.tourItems[0]
    if (postPurchase === 'tour-accommodation' && tourItem) {
      const leadTraveller = tourItem.tour.travellers.find(traveller => !!traveller.isLeadPassenger) ?? tourItem.tour.travellers[0]
      return {
        bookingPhone: `+${phonePrefix}${phone}`,
        bookingEmail: email,
        guestFirstName: leadTraveller.firstName,
        guestLastName: leadTraveller.lastName,
      }
    }
    if (bedbankItem && (postPurchase === 'change-dates' || postPurchase === 'change-package')) {
      return {
        bookingPhone: bedbankItem.bookingPhone,
        bookingEmail: bedbankItem.bookingEmail,
        guestFirstName: bedbankItem.rooms[0]?.guestFirstName,
        guestLastName: bedbankItem.rooms[0]?.guestLastName,
      }
    }

    return undefined
  },
)
